import React, { useState, useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ChevronDown, Check } from 'lucide-react';

export default function MobileSelect({ value, onValueChange, options, placeholder, label }) {
  const [isMobile, setIsMobile] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const selectedOption = options.find(opt => opt.value === value);

  // Desktop: use regular Select
  if (!isMobile) {
    return (
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  // Mobile: use Drawer
  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>
        <Button 
          variant="outline" 
          className="w-full justify-between select-none"
        >
          <span className={selectedOption ? '' : 'text-muted-foreground'}>
            {selectedOption ? selectedOption.label : placeholder}
          </span>
          <ChevronDown className="h-4 w-4 opacity-50" />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="dark:bg-slate-900 dark:border-slate-800">
        <DrawerHeader>
          <DrawerTitle className="dark:text-white">{label || placeholder}</DrawerTitle>
        </DrawerHeader>
        <div className="px-4 pb-8 max-h-[60vh] overflow-y-auto">
          {options.map(option => (
            <button
              key={option.value}
              onClick={() => {
                onValueChange(option.value);
                setOpen(false);
              }}
              className="w-full flex items-center justify-between py-4 px-4 border-b dark:border-slate-800 last:border-0 select-none hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
            >
              <span className="text-left dark:text-white">{option.label}</span>
              {value === option.value && (
                <Check className="h-5 w-5 text-teal-600 dark:text-teal-400" />
              )}
            </button>
          ))}
        </div>
      </DrawerContent>
    </Drawer>
  );
}